import React, { useCallback, useEffect, useState } from 'react';
import { Table } from 'antd';
import HeadingTypography from 'src/app/components/shared/Typography/Heading';
import TextTypography from 'src/app/components/shared/Typography/Text';
import { getLeadsStatusCount } from 'src/app/services/lead';
import { LeadStatusEnum } from '@rasayi-workspace/shared';
import { useLeadContext } from '@contexts';

const columns = [
    {
        title: <HeadingTypography fontSize={16}>Hot Leads</HeadingTypography>,
        dataIndex: 'hotLeads',
        key: 'hotLeads',
        render: (value: number) => <TextTypography fontSize={16}>{value}</TextTypography>,
    },
    {
        title: <HeadingTypography fontSize={16}>Call Back Later</HeadingTypography>,
        dataIndex: 'callBackLater',
        key: 'callBackLater',
        render: (value: number) => <TextTypography fontSize={16}>{value}</TextTypography>,
    },
    {
        title: <HeadingTypography fontSize={16}>Details Shared</HeadingTypography>,
        dataIndex: 'detailsShared',
        key: 'detailsShared',
        render: (value: number) => <TextTypography fontSize={16}>{value}</TextTypography>,
    },
    {
        title: <HeadingTypography fontSize={16}>Doc Awaiting</HeadingTypography>,
        dataIndex: 'docAwaiting',
        key: 'docAwaiting',
        render: (value: number) => <TextTypography fontSize={16}>{value}</TextTypography>,
    },
    {
        title: <HeadingTypography fontSize={16}>Contacted</HeadingTypography>,
        dataIndex: 'contacted',
        key: 'contacted',
        render: (value: number) => <TextTypography fontSize={16}>{value}</TextTypography>,
    },

    {
        title: <HeadingTypography fontSize={16}>Plan Finalized</HeadingTypography>,
        dataIndex: 'planFinalized',
        key: 'planFinalized',
        render: (value: number) => <TextTypography fontSize={14}>{value}</TextTypography>,
    },
    {
        title: <HeadingTypography fontSize={16}>Drop-off</HeadingTypography>,
        dataIndex: 'deadLead',
        key: 'deadLead',
        render: (value: number) => <TextTypography fontSize={16}>{value}</TextTypography>,
    },
];

const leadStatusStats = {
    hotLeads: 0,
    callBackLater: 0,
    detailsShared: 0,
    outOfStations: 0,
    docAwaiting: 0,
    contacted: 0,
    deadLead: 0,
    planFinalized: 0,
};
interface ILeadStatusStats {
    hotLeads: number;
    callBackLater: number;
    detailsShared: number;
    docAwaiting: number;
    contacted: number;
    deadLead: number;
    planFinalized: number;
}

const LeadTable: React.FC = () => {
    const { date } = useLeadContext();

    const [data, setData] = useState<ILeadStatusStats>(leadStatusStats);

    const fetchLeadsCount = useCallback(async () => {
        const resp = await getLeadsStatusCount(date);
        setData({
            hotLeads: resp[LeadStatusEnum.HOT_LEAD],
            callBackLater: resp[LeadStatusEnum.CALL_BACK_LATER],
            detailsShared: resp[LeadStatusEnum.DETAILS_SHARED],
            docAwaiting: resp[LeadStatusEnum.DOC_AWAITING],
            contacted: resp[LeadStatusEnum.CONTACTED],
            deadLead: resp[LeadStatusEnum.DEAD_LEAD],
            planFinalized: resp[LeadStatusEnum.PLAN_FINALIZED],
        });
    }, [date.startDate, date.endDate]);
    useEffect(() => {
        fetchLeadsCount();
    }, [fetchLeadsCount]);

    return (
        <div className="bg-gray-100 rounded-lg">
            <Table
                scroll={{ x: true }}
                rowClassName="bg-white"
                columns={columns}
                dataSource={[data]}
                pagination={false}
                className="bg-white rounded-lg shadow-sm"
                components={{
                    header: {
                        cell: ({ children, ...restProps }: any) => (
                            <th {...restProps} className="!bg-white ">
                                {children}
                            </th>
                        ),
                    },
                }}
            />
        </div>
    );
};

export default LeadTable;
